import {gql} from "@apollo/client";

export const USER_NOTIFICATIONS = gql`
query UserNotifications($profileId: Int!, $isRead: Boolean, $notificationType: [String], $page: Int, $pageSize: Int) {
    userNotifications(profileId: $profileId, isRead: $isRead, notificationType: $notificationType, page: $page, pageSize: $pageSize) {
        objects{
            id
            isRead
            readAt
            notification{
                id
                title
                message
                createdAt
                type
                resourceId
                resourceName
                sender{
                    id
                    fullName
                }
                externalLink
            }            
        }
        page
        pages
        hasNext
        hasPrev
        totalCount
    }
}
`;

export const SENT_NOTIFICATIONS = gql`
query SentNotifications($profileId: Int!, $notificationType: [String], $page: Int, $pageSize: Int) {
    sentNotifications(profileId: $profileId, notificationType: $notificationType, page: $page, pageSize: $pageSize) {
        objects{
            id
            title
            message
            createdAt
            type
            resourceId
            resourceName
            sender{
                id
                fullName
            }
            externalLink
        }
        page
        pages
        hasNext
        hasPrev
        totalCount
    }
}
`;
